import { CLIENT_ENVS } from '@/helpers/constants';
import { safeClientCallback } from '@/modules/server/helpers-client';

const { GA_MEASUREMENT_ID } = CLIENT_ENVS;
export type TEventCommand = 'config' | 'event';

declare global {
  interface Window {
    gtag: (
      command: TEventCommand,
      eventId?: string,
      params?: Record<string, any>
    ) => void;
  }
}

/**
 * @description This function sends a Google Analytics events.
 * @param eventAction - The action name for the event.
 * @param eventParams - The parameters for the event.
 */
export const sendGAEvent = safeClientCallback(
  <EventParams extends Record<string, any>>(
    eventAction: string,
    eventParams: EventParams
  ) => {
    const debugEvents = localStorage.getItem('debugGAEvents');
    if (
      debugEvents &&
      (debugEvents === 'true' || debugEvents === eventParams?.event_category)
    ) {
      console.log({
        gaConfig: window?.debugGAConfigData,
        eventAction,
        eventParams,
      });
    }

    if (!window.gtag) return;
    window.gtag('event', eventAction, eventParams);
  },
  undefined
);

/**
 * @param config - The configuration object for Google Analytics.
 * @description This function sets the Google Analytics configuration.
 */
export const setGAConfig = safeClientCallback(
  <GAConfig extends Record<string, any>>(config: GAConfig) => {
    const debugEvents = localStorage.getItem('debugGAEvents');

    if (debugEvents === 'true') {
      window.debugGAConfigData = config;
    }

    if (!window.gtag) return;
    window.gtag('config', GA_MEASUREMENT_ID, config);
  },
  undefined
);
